import React from 'react';
import styles from "./Container.module.scss";

interface ContainerProps {
  children: React.ReactNode;
  id?: string;
  backgroundColor?: string;
}

export const Container = ({
                            children,
                            id,
                            backgroundColor,
                          }: ContainerProps) => {
  const sectionStyle: React.CSSProperties = {
    ...(backgroundColor && { backgroundColor }),
  };

  return (
    <section
      className={styles.block}
      id={id}
      style={sectionStyle}
    >
      <div className={styles.container}>{children}</div>
    </section>
  );
}
